import * as React from "react"

const CloseXIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-label="close"
    {...props}
  >
    <path
      stroke="#051711"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.625 4.375-11.25 11.25M15.625 15.625 4.375 4.375"
    />
  </svg>
)
export default CloseXIcon
